"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ORDINAL_FROM_NUMBER = exports.FORMAT_TIME_WITH_NUMERALS = exports.FORMAT_TIME = exports.SET_LOCALE = exports.GET_LOCALE = exports.GET_TIME = exports.GET_WEEKDAY_FROM_TIME = exports.GET_TIME_NOW = void 0;
require("./dayjs/locales");
var dayjs_1 = __importDefault(require("dayjs"));
var advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
var numerals_1 = __importDefault(require("./dayjs/numerals"));
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(numerals_1.default);
exports.GET_TIME_NOW = function (timezone) {
    if (timezone === void 0) { timezone = process.env.REACT_APP_timezone_default; }
    return dayjs_1.default(new Date().toLocaleString(timezone));
};
exports.GET_WEEKDAY_FROM_TIME = function (time) {
    return dayjs_1.default(time).day();
};
exports.GET_TIME = function (time) {
    return dayjs_1.default(time);
};
exports.GET_LOCALE = function () {
    var locale = dayjs_1.default().locale();
    // if value is falsy then return default language
    if (!locale)
        return 'en';
    // day js has old language codes for chinese language, so we need to
    // do a conversion here
    if (locale.toLowerCase() === 'zh-cn') {
        locale = 'zh-Hans';
    }
    return locale;
};
exports.SET_LOCALE = function (locale) {
    if (locale === void 0) { locale = 'en'; }
    var dayjsLocale = locale;
    // day js has old language codes for chinese language, so we need to
    // do a conversion here
    if (locale.toLowerCase() === 'zh-hans') {
        // must be in lowercase here, because dayjs is case sensitive
        dayjsLocale = 'zh-cn';
    }
    dayjs_1.default.locale(dayjsLocale);
    return locale;
};
exports.FORMAT_TIME = function (time, format) {
    return time.format(format);
};
exports.FORMAT_TIME_WITH_NUMERALS = function (time, format) {
    return time.formatNumerals(format, dayjs_1.default().locale());
};
exports.GET_ORDINAL_FROM_NUMBER = function (_number) {
    var DATE = dayjs_1.default();
    DATE.$D = +_number;
    return exports.FORMAT_TIME_WITH_NUMERALS(DATE, 'Do');
};
